import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseDeleteEstablishmentTechnicalProfessionalProps {
  id: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useDeleteEstablishmentTechnicalProfessional = ({
  id,
  onSuccess,
  onError,
}: UseDeleteEstablishmentTechnicalProfessionalProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteEstablishmentTechnicalProfessional'],
    mutationFn: () => privateAxios.delete(`/maintenance/establishment_technical_professionals/${id}`),
    onSuccess,
    onError,
  })
}
